import * as url from "./url_helper";
import { get } from "./api_helper";

export const getReports = () => get(url.GET_REPORTS);
export const getFeedback = () => get(url.GET_FEEDBACK);

export const deleteReport = (id) => del(url.DELETE_REPORT + id);
export const deleteFeedback = (id) => del(url.DELETE_FEEDBACK + id);